import React, { useEffect, useRef, useState } from 'react';
import { onClickPageButtonTracking, usePageTracking, useScrollTracking } from '../../../hooks/pageTracking';
import { DeepLinkDefaultLink, getDeepLinkUri } from '../../../utils/deepLinkUtils';
import Footer from '../../../components/Footer';
import LandingFooter from '../../../components/landing/LandingFooter';

export default function AppThemeTestA() {
  const PAGE_NAME = 'APP_THEME_TEST_A';
  const scrollRef = useRef<HTMLDivElement>(null);
  const [deepLinkUri, setDeepLinkUri] = useState(DeepLinkDefaultLink);
  const BUTTON_LABEL = '지금 당장 잠들러 가기';

  usePageTracking(PAGE_NAME);
  useScrollTracking(scrollRef, PAGE_NAME);

  const fetchAndSetDeepLinkUri = async () => {
    const deepLinkUri = await getDeepLinkUri(PAGE_NAME.toLowerCase());
    if (deepLinkUri) {
      console.log('[Success] fetchAndSetDeepLinkUri ~ deepLinkUri:', deepLinkUri);
      setDeepLinkUri(deepLinkUri);
    } else {
      console.error('[Failed] fetchAndSetDeepLinkUri ~ deepLinkUri:', deepLinkUri);
    }
  };
  useEffect(() => {
    fetchAndSetDeepLinkUri();
  }, []);

  return (
    <div ref={scrollRef} className='landing-wrap'>
      <img src="/landing/A.jpg" alt="상세페이지 이미지" style={{ width: '100%', display: 'block' }} />
      <a
        id='floating-button'
        className='landing-floating-btn landing-floating-active-btn'
        href={deepLinkUri}
        onClick={() => onClickPageButtonTracking(PAGE_NAME, BUTTON_LABEL)}
      >
        {BUTTON_LABEL}
      </a>
      <LandingFooter />
    </div>
  );
}
